export class Browser {
  // Firefox 1.0+
  static isFirefox(): boolean {
    return typeof (window as any).InstallTrigger !== 'undefined';
  }

  static getFirefoxMajorVersion(userAgent?: string): number {
    userAgent = userAgent || navigator.userAgent;
    const firefoxVersionRegex = /firefox\/(\S+)/;
    const match = userAgent.toLowerCase().match(firefoxVersionRegex);
    if (match) {
      return match[1].split('.').map((x) => parseInt(x))[0];
    }
  }

  // Internet Explorer 6-11
  static isIE(): boolean {
    return (
      navigator.userAgent.indexOf('MSIE') !== -1 ||
      !!(document as any).documentMode
    );
  }

  // Edge 20+
  static isEdge(): boolean {
    return !Browser.isIE() && !!(window as any).StyleMedia;
  }

  // Chrome 1+
  static isChrome(context: Window & typeof globalThis = window): boolean {
    return !!(context as any).chrome;
  }

  // At least Safari 3+: "[object HTMLElementConstructor]"
  static isSafari(): boolean {
    return (
      Object.prototype.toString
        .call(window.HTMLElement)
        .indexOf('Constructor') > 0 ||
      navigator.userAgent.toLowerCase().indexOf('safari') !== -1
    );
  }

  // IOS Chrome
  static isIOSChrome(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('crios') !== -1;
  }
}
